// extracted by mini-css-extract-plugin
export default {"menu-icon":"fWcIOWRwglKHI4N0t418"};